import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const PAGE_WIDTH = 210;
const PAGE_HEIGHT = 295;

export class PdfReportGenerator {
  // infoBlockRef = null;
  chartsBlockRefs = [];
  chartsTitleRef = null;
  chartsFooterRef = null;
  spaceOnPageLeft = PAGE_HEIGHT;
  chartsOnPage = 0;
  pdf = null;
  isTitleAdded = false;
  footerImage = null;
  isFirstPage = false;

  constructor(
    // infoBlockRef,
    chartsBlockRefs,
    chartsTitleRef = null,
    chartsFooterRef = null
  ) {
    // this.infoBlockRef = infoBlockRef;
    this.chartsBlockRefs = chartsBlockRefs;
    this.chartsTitleRef = chartsTitleRef;
    this.chartsFooterRef = chartsFooterRef;
    this.pdf = new jsPDF('p', 'mm');
  }

  async addInfoBlockToPdf() {
    const canvas = await html2canvas(this.infoBlockRef, {
      scrollY: -window.scrollY,
    });
    let imgData = canvas.toDataURL('image/png');
    const imgWidth = PAGE_WIDTH - 10;
    let imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 10; // give some top padding to first page

    this.pdf.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight);
    heightLeft -= PAGE_HEIGHT;
    while (heightLeft >= 0) {
      position += heightLeft - imgHeight; // top padding for other pages
      this.pdf.addPage();
      this.pdf.addImage(
        imgData,
        'PNG',
        5,
        position,
        imgWidth,
        imgHeight
      );
      heightLeft -= PAGE_HEIGHT;
    }
  }

  async addChartsTitleToPdf() {
    const canvas = await html2canvas(this.chartsTitleRef, {
      scrollY: -window.scrollY,
    });
    let imgData = canvas.toDataURL('image/png');
    const imgWidth = PAGE_WIDTH - 20;
    let imgHeight = (canvas.height * imgWidth) / canvas.width;
    let position = 10; // give some top padding to first page
    this.pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    this.spaceOnPageLeft = this.spaceOnPageLeft - imgHeight;
    this.isTitleAdded = true;
  }

  async addPageForChart() {
    if (this.isFirstPage === false) {
      this.isFirstPage = true;
    } else  {
      this.pdf.addPage();
    }
    this.chartsOnPage = 0;
    if (this.chartsFooterRef) {
      const imgWidth = PAGE_WIDTH - 20;
      if (!this.footerImage) {
        const canvas = await html2canvas(this.chartsFooterRef, {
          scrollY: -window.scrollY,
        });
        this.footerImage = {
          data: canvas.toDataURL('image/png'),
          height: (canvas.height * imgWidth) / canvas.width,
        };
      }
      const { data, height } = this.footerImage;
      let position = PAGE_HEIGHT - height - 5;
      this.pdf.addImage(data, 'PNG', 10, position, imgWidth, height);
      this.spaceOnPageLeft = position;
    } else {
      this.spaceOnPageLeft = PAGE_HEIGHT;
    }
  }

  addImgToPdf(imgData, position, imgHeight) {
    this.pdf.addImage(imgData, 'PNG', 10, position, PAGE_WIDTH - 20, imgHeight);
    this.spaceOnPageLeft = this.spaceOnPageLeft - imgHeight;
    this.chartsOnPage += 1;
  }

  async addChartBlockToPdf(chartRef) {
    let pdfItems = chartRef.querySelectorAll('.report-pdf-item');

    for (let i in pdfItems) {
      if (!pdfItems[i].innerHTML) {
        continue
      }

      const canvas = await html2canvas(pdfItems[i], {
        scrollY: -window.scrollY,
      });
      let imgData = canvas.toDataURL('image/png');
      let imgHeight = (canvas.height * PAGE_WIDTH - 20) / canvas.width;
      let heightLeft = imgHeight;
      let position = 10; // give some top padding to first page
      if (this.spaceOnPageLeft < imgHeight + 20 || (this.chartsOnPage && pdfItems[i].classList.contains('report-pdf-heading'))) {
        await this.addPageForChart();
        this.addImgToPdf(imgData, position, imgHeight);
        heightLeft -= PAGE_HEIGHT;
        while (heightLeft >= 0) {
          position += heightLeft - imgHeight + 10; // top padding for other pages
          await this.addPageForChart();
          this.addImgToPdf(imgData, position, imgHeight);
          heightLeft -= PAGE_HEIGHT;
        }
      } else {
        position = PAGE_HEIGHT - this.spaceOnPageLeft + 5 * this.chartsOnPage + 20;
        this.addImgToPdf(imgData, position, imgHeight);
      }
    }
  }

  async populateWithDataAndSave(reportName) {
    window.scrollTo(0, 0);
    // await this.addInfoBlockToPdf();
    await this.addPageForChart();
    if (this.chartsTitleRef) {
      await this.addChartsTitleToPdf();
    }
    for (let i = 0; i < this.chartsBlockRefs.length; i += 1) {
      await this.addChartBlockToPdf(this.chartsBlockRefs[i]);
    }
    this.pdf.save(reportName);
  }
}
